// SAFE MODE: PWA - Register service worker for مشهد (photographer-only, production only)

const PWA_SW_URL = '/sw.js';
const PWA_SCOPE = '/photographer-dashboard/';

/**
 * Register PWA service worker when caller confirms photographer context.
 * Call from photographer dashboard when user.role === 'photographer'.
 * Registers in both dev and production so beforeinstallprompt can fire (button can appear).
 * @param {boolean} isPhotographer - Must be true (from userProfile?.role === 'photographer')
 * @returns {Promise<ServiceWorkerRegistration | null>}
 */
export async function registerPwaServiceWorker(isPhotographer) {
  if (!isPhotographer) return null;
  if (!('serviceWorker' in navigator)) return null;

  try {
    const registration = await navigator.serviceWorker.register(PWA_SW_URL, { scope: '/' });
    return registration;
  } catch (err) {
    console.warn('SAFE MODE: PWA SW registration failed', err);
    return null;
  }
}

/**
 * Unregister PWA service worker (e.g. when user is no longer photographer).
 */
export async function unregisterPwaServiceWorker() {
  if (!('serviceWorker' in navigator)) return;
  try {
    const regs = await navigator.serviceWorker.getRegistrations();
    for (const reg of regs) {
      if (reg.active?.scriptURL?.includes('sw.js')) {
        await reg.unregister();
      }
    }
  } catch (_) {}
}
